import { QueryStatus } from '@reduxjs/toolkit/query';
import { SyncManager } from 'db';
import { useIsOnline } from 'hooks';
import { useField } from 'react-final-form';
import { useFormVehicleId } from './useFormVehicleId';

type SaveFn = (payload: { selected?: boolean; notes?: string; label?: string }) => Promise<void>;

export const useUpdateCheckbox = (checkboxId: number, sectionId: string, i: number): [SaveFn, QueryStatus] => {
  const {
    input: { value: serverId }
  } = useField(`${sectionId}.id`);

  const vehicleId = useFormVehicleId();

  const save = async (payload: { selected?: boolean; notes?: string; label?: string }) => {
    if (!vehicleId || Object.keys(payload).length === 0) return;
    const syncManager = SyncManager.getInstance(vehicleId);

    const isNewCheckbox = !checkboxId || checkboxId.toString() === `${serverId}-${i}`;
    const entityType = isNewCheckbox ? 'new_checkbox' : 'checkbox';
    const entityId = checkboxId || `${serverId}-${i}`;

    await syncManager.queueEntityUpdate(entityId, entityType, Object.entries(payload));
  };

  return [save, QueryStatus.uninitialized];
};
